export const useReportNotFoundUrlApi = () => {
  const store = (url: string) => {
    return useApiPost(`/report-not-found`, {
      url,
    })
  }

  return { store }
}
